/**
 * @generated SignedSource<<22f12c69514c8647227dd1a151026b7a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SaveAsTemplate_viewer$data = {
  readonly account: {
    readonly billingAccount: {
      readonly hasAccessToPromptHeadings: boolean;
    };
  };
  readonly canCreateWorkspaceTemplate: boolean;
  readonly " $fragmentType": "SaveAsTemplate_viewer";
};
export type SaveAsTemplate_viewer$key = {
  readonly " $data"?: SaveAsTemplate_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"SaveAsTemplate_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SaveAsTemplate_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "canCreateWorkspaceTemplate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Account",
      "kind": "LinkedField",
      "name": "account",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "BillingAccount",
          "kind": "LinkedField",
          "name": "billingAccount",
          "plural": false,
          "selections": [
            {
              "alias": "hasAccessToPromptHeadings",
              "args": [
                {
                  "kind": "Literal",
                  "name": "feature",
                  "value": "prompt_headings"
                }
              ],
              "kind": "ScalarField",
              "name": "hasAccessToFeature",
              "storageKey": "hasAccessToFeature(feature:\"prompt_headings\")"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "be79b755af0210d7ef27d679757c6998";

export default node;
